import { api, authHeader } from "../configs/axiosConfigs";

const parseApiErrorMessage = (res, fallback) =>
  res?.message || res?.Message || fallback;

const normalize = (res, fallbackMessage) => {
  if (!res || res.isSuccess === false) {
    return {
      error: parseApiErrorMessage(res, fallbackMessage),
      data: null,
    };
  }
  return { error: null, data: res.data ?? res.Data ?? res };
};

const CustomerFinanceApi = {
  getHeaderSummary: async () => {
    const response = await api.request({
      url: "/SLN/Customer/Finance/HeaderSummary",
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getDashboardOverview: async () => {
    const response = await api.request({
      url: "/SLN/Customer/Dashboard/Overview",
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  normalizeHeaderSummary: (res) =>
    normalize(res, "بارگذاری خلاصه مالی ناموفق بود."),

  normalizeDashboardOverview: (res) =>
    normalize(res, "بارگذاری داشبورد ناموفق بود."),
};

export default CustomerFinanceApi;
